import React from 'react';
import { Formik, Form, Field } from 'formik';
import PropTypes from 'prop-types';
import { FormMultiSelect } from '@getro/rombo';
import { FormikAutoSubmit } from '../../../../components/atoms/formikAutoSubmit';
import { teamInvolvementOptions } from '../../utils/teamInvolvementOptions';

export const TeamInvolvementFilter = ({ value, setFilters }) => {
  const onSubmit = ({ teamInvolvement }) => {
    setFilters({ teamInvolvement: teamInvolvement || [] });
  };

  // Convert stored values back to option objects for the multi-select
  const selectedValues = Array.isArray(value)
    ? value
        .map((v) => {
          const val = typeof v === 'object' ? v.value : v;
          return teamInvolvementOptions.find((opt) => opt.value === val);
        })
        .filter(Boolean)
    : [];

  return (
    <Formik initialValues={{ teamInvolvement: selectedValues }} onSubmit={onSubmit} enableReinitialize>
      <Form>
        <FormikAutoSubmit />
        <Field
          name="teamInvolvement"
          label="Assisted by team"
          placeholder="Select"
          component={FormMultiSelect}
          options={teamInvolvementOptions}
          size="small"
          anchorToBody
        />
      </Form>
    </Formik>
  );
};

TeamInvolvementFilter.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  setFilters: PropTypes.func.isRequired,
};

TeamInvolvementFilter.defaultProps = {
  value: [],
};
